import * as React from 'react';
import { Group, Box, Button, Text, createStyles } from '@mantine/core';
import { useTranslation } from 'react-i18next';

// Local components
import { InterpolatedFormCopy } from '../InterpolatedFormCopy';

const useStyles = createStyles((theme) => {
    return {
        description: {
            whiteSpace: 'pre-line'
        }
    };
});

interface LandingSlideProps {
    content?: string | React.ReactNode;
    data: Record<string, any>;
    dismissCallback: () => void;
}

export const LandingSlide: React.FC<LandingSlideProps> = ({ content, dismissCallback, data, ...props }) => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation();

    return (
        <Box>
            <Text mb="xl" className={classes.description}>
                {typeof content === 'string' ? <InterpolatedFormCopy copy={content} {...{ data }} /> : content}
            </Text>
            <Group position="right">
                <Button onClick={dismissCallback}>{t('getStarted', { ns: 'common' })}</Button>
            </Group>
        </Box>
    );
};
